export const appConfig = {
    REACT_APP_ENVIRONMENT: process.env.REACT_APP_AUTH0_DOMAIN?.toString() as string,
    REACT_APP_API_URL:  process.env.REACT_APP_API_URL?.toString() as string,
    REACT_APP_DEFAULT_TIMEZONE:  'America/Newyork'
}